// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Shipments_establishments__1SVDb","header":"Shipments_header__2xuys","tableHeader":"Shipments_tableHeader__1PiTp"};